import { bearlog } from "@sillyscribe95/bear-ui-web";

let sharp = "#";

function asdAE(a, next) {
  let oaskdwe = next ? `${next}♭` : a;
  const asdasd = {
    chord: oaskdwe,
  };

  return asdasd;
}

export function getKeyChord(key) {
  const chodIC = {};
  ["c", "cs", "d", "ds", "e", "f", "fs", "g", "gs", "a", "as", "b", "c"].map(
    function (fsdfsd, ixn) {
      chodIC[fsdfsd] = ixn;
    }
  );

  let sdresd =
    //
    chodIC[key];

  bearlog.lug("___ getKeyChrd ___", chodIC, sdresd);

  return sdresd;
}

const adsfser = {
  1: asdAE("C"),
  2: asdAE(`C`, `D`),
  3: asdAE(`D`),
  4: asdAE(`D`, `E`),
  5: asdAE(`E`),
  6: asdAE(`F`),
  7: asdAE(`F`, `G`),
  8: asdAE(`G`),
  9: asdAE(`G`, `A`),
  10: asdAE(`A`),
  11: asdAE(`A`, `B`),
  12: asdAE(`B`),
};

export const chordKeyDict =
  //
  adsfser;
